import { useQuery } from "@tanstack/react-query";
import { issueApi } from "lib/api";

export const issueQueryKeys = {
  byId: (issueId: number) => ["issue", "byId", issueId] as const,
  influencesCount: (issueId: number) => ["issue", "influencesCount", issueId] as const,
};

export const useIssueByIdQuery = (issueId: number | null | undefined) =>
  useQuery({
    queryKey: issueId ? issueQueryKeys.byId(issueId) : ["issue", "byId", "empty"],
    queryFn: () => issueApi.getById(issueId as number),
    enabled: typeof issueId === "number" && issueId > 0,
  });

export const useIssueInfluencesCountQuery = (issueId: number | null | undefined) =>
  useQuery({
    queryKey: issueId ? issueQueryKeys.influencesCount(issueId) : ["issue", "influencesCount", "empty"],
    queryFn: () => issueApi.getInfluencesCount(issueId as number),
    enabled: typeof issueId === "number" && issueId > 0,
  });

